/**
 * @Author: Zewei
 * @Date:   2018-01-29T09:58:52+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-08T11:53:29+08:00
 */
import { DepartmentStructure } from '../constants/department-structure-constants.js';
import _util from '../utils/index.js';
import departmentStructureService from '../services/DepartmentStructure/department-structure-service.js';
import departmentDutyService from '../services/DepartmentStructure/department-duty-service.js';
import departmentPositionService from '../services/DepartmentStructure/department-position-service.js';
import { message } from 'antd';
// 组织结构
export function fetchDepartmentsList (params) {
    return dispatch => {
        departmentStructureService.getDepartmentsList(params, (res) => {
            if (res.data) {
                dispatch({
                    type: DepartmentStructure.ActionTypes.FETCHSUCCESS,
                    payload: {
                        departmentsList: res.data,
                        expandedRowKey: [`${res.data[0].id}`],
                        actionStatus: false
                    }
                })
            } else {
                throw new Error('后台数据接口有问题')
            }
        }, (err) => {
            dispatch({
                type: DepartmentStructure.ActionTypes.FETCHFAILURE,
                payload: {
                    actionStatus: false
                }
            })
            // _util.errorTips('后台数据接口')
        })
    }
}
export function fetchDepartmentsByCampusList (params) {
    return dispatch => {
        departmentStructureService.getDepartmentsList(params, (res) => {
            if (res.data) {
                dispatch({
                    type: DepartmentStructure.ActionTypes.FETCHSUCCESS,
                    payload: {
                        departmentsByCampusList: res.data,
                        expandedRowKey: [`${res.data[0].id}`],
                        actionStatus: false
                    }
                })
            } else {
                throw new Error('后台数据接口有问题')
            }
        }, (err) => {
            dispatch({
                type: DepartmentStructure.ActionTypes.FETCHFAILURE,
                payload: {
                    actionStatus: false
                }
            })
            // _util.errorTips('后台数据接口')
        })
    }
}
export function fetchDepartmentDetail (params) {
    return dispatch => {
        departmentStructureService.getDepartmentsDetail(params, (res) => {
            if (res.data) {
                dispatch({
                    type: DepartmentStructure.ActionTypes.FETCHSUCCESS,
                    payload: {
                        departmentDetail: res.data,
                        actionStatus: true,
                        // asyncModalVisible: true,
                    }
                })
            } else {
                throw new Error('后台数据接口有问题')
            }
        }, (err) => {
            dispatch({
                type: DepartmentStructure.ActionTypes.FETCHFAILURE,
                payload: {
                    actionStatus: false
                }
            })
            // _util.errorTips('后台数据接口')
        })
    }
}


export function reviewAttendanceRecord (params, callback) {

    return dispatch => {
        departmentStructureService.reviewAttendanceRecord(params, (res) => {
            if (res.data) {
                dispatch({
                    type: DepartmentStructure.ActionTypes.FETCHSUCCESS,
                    payload: {
                        data: res.data
                        // asyncModalVisible: true,
                    }
                })

                if ('function' === typeof callback) {
                    callback(res);
                }
            } else {
                throw new Error('后台数据接口有问题')
            }
        }, (err) => {
            dispatch({
                type: DepartmentStructure.ActionTypes.FETCHFAILURE,
                payload: {
                    actionStatus: false
                }
            })
            // _util.errorTips('后台数据接口')
        })
    }
}






export function fetchDepartmentsInit (params) {
    return dispatch => {
        departmentStructureService.getDepartmentsInit((res) => {
            if (res.data) {
                dispatch({
                    type: DepartmentStructure.ActionTypes.FETCHSUCCESS,
                    payload: {
                        users: res.data.users
                    }
                })
            } else {
                throw new Error('后台数据接口有问题')
            }
        }, (err) => {
            dispatch({
                type: DepartmentStructure.ActionTypes.FETCHFAILURE,
                payload: {
                    err
                }
            })
        })
    }
}
export function createNewDepartment (params) {
    return dispatch => {
        departmentStructureService.createNewDepartment((res) => {
            if (res.data) {
                dispatch({
                    type: DepartmentStructure.ActionTypes.CREATESUCCESS,
                    payload: {
                        // departmentsInit: res.data
                    }
                })
                _util.successTips('创建部门成功')
            } else {
                throw new Error('创建部门失败')
            }
        }, (err) => {
            dispatch({
                type: DepartmentStructure.ActionTypes.CREATEFAILURE,
                payload: {
                    err
                }
            })
            _util.errorTips('创建部门失败')
        })
    }
}
export function multiCreateDepartments (data) {
    return dispatch => {
        departmentStructureService.multiCreateDepartments(data, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: DepartmentStructure.ActionTypes.CREATESUCCESS,
                    payload: {
                        actionStatus: true
                        // departmentsInit: res.data
                    }
                });
                _util.successTips('创建部门成功')
            } else {
                throw new Error('后台数据接口有问题')
            }
        }, (err) => {
            dispatch({
                type: DepartmentStructure.ActionTypes.CREATEFAILURE,
                payload: {
                    actionStatus: false,
                    err
                }
            })
            _util.errorTips('创建部门失败')
        })
    }
}
export function updateNewDepartment (data) {
    return dispatch => {
        departmentStructureService.updateNewDepartment(data, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: DepartmentStructure.ActionTypes.UPDATESUCCESS,
                    payload: {
                        actionStatus: true
                    }
                })
            } else {
                throw new Error('后台数据接口有问题')
            }
        }, (err) => {
            dispatch({
                type: DepartmentStructure.ActionTypes.UPDATEFAILURE,
                payload: {
                    actionStatus: false,
                    err
                }
            })
        })
    }
}
export function mergeDepartments (data) {
    return dispatch => {
        departmentStructureService.mergeDepartments(data, (res) => {
            if (res.data) {
                dispatch({
                    type: DepartmentStructure.ActionTypes.UPDATESUCCESS,
                    payload: {
                        actionStatus: true
                    }
                })
                _util.successTips('合并部门成功')
            } else {
                throw new Error('后台数据接口有问题')
            }
        }, (err) => {
            dispatch({
                type: DepartmentStructure.ActionTypes.UPDATEFAILURE,
                payload: {
                    err
                }
            })
            _util.errorTips('合并部门失败')
        })
    }
}
export function sequenceDepartments (data) {
    return dispatch => {
        departmentStructureService.sequenceDepartments(data, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: DepartmentStructure.ActionTypes.UPDATESUCCESS,
                    payload: {
                        actionStatus: true
                    }
                })
                _util.successTips('移动成功')
            } else {
                throw new Error('后台数据接口有问题')
            }
        }, (err) => {
            dispatch({
                type: DepartmentStructure.ActionTypes.UPDATEFAILURE,
                payload: {
                    actionStatus: false
                }
            })
        })
    }
}
export function deleteDepartment (data) {
    return dispatch => {
        departmentStructureService.deleteDepartment(data, (res) => {
            if (res.data.Success) {
                dispatch({
                    type: DepartmentStructure.ActionTypes.UPDATESUCCESS,
                    payload: {
                        actionStatus: true
                    }
                })
                _util.successTips('删除部门成功')
            } else {
                throw new Error('后台数据接口有问题')
            }
        }, (err) => {
            dispatch({
                type: DepartmentStructure.ActionTypes.UPDATEFAILURE,
                payload: {
                    actionStatus: false
                }
            })
            _util.errorTips('删除部门失败')
        })
    }
}


// 职务规划
export function fetchDutyCategoryList() {
	return dispatch => {
		departmentDutyService.fetchDutyCategoryList(res => {
			dispatch({
				type: DepartmentStructure.ActionTypes.FETCHDUTYCATEGORYLISTSUCCESS,
				payload: {
					dutyCategoryList: res.data.Data,
					dutyCategoryListStatus: true,
					dutyCategoryPage: res.data.Page,
					dutyCategoryPageSize: res.data.PageSize,
					dutyCategoryTotal: res.data.Total,
				}
			})
		}, error => {});
	}
}
export function closeDutyCategoryModal() {
	return dispatch => dispatch({
		type: DepartmentStructure.ActionTypes.CLOSEDUTYCATEGORYMODAL,
		payload: { dutyCategoryListStatus: false }
	});
}
export function newDutyCategory(item){
    return dispatch => dispatch({
        type: DepartmentStructure.ActionTypes.NEWDUTYCATEGORYSUCCESS,
        payload: { item: item }
    });
}
export function addDutyCategory(posts, index, callback) {
	return dispatch => {
		departmentDutyService.addDutyCategory(posts, res => {
            // console.log(res);
            if (res.data.Success) {
                dispatch({
                    type: DepartmentStructure.ActionTypes.ADDDUTYCATEGORYSUCCESS,
                    payload: {id: res.data.ModelId, index: index}
                });
            }
			else{
                _util.errorTips(res.data.Errors)
                throw new Error('新增职务分类失败')
            }
            if ("function" === typeof callback) {
                callback(true);
            }
		}, error => {});
	}
}
export function changeDutyName(index, name) {
	return dispatch => dispatch({
		type: DepartmentStructure.ActionTypes.CHANGEDUTYNAME,
		payload: { index: index, name: name }
	});
}
export function saveDutyCategory(puts, index, callback) {
    return dispatch => {
        departmentDutyService.saveDutyCategory(puts, res => {
            dispatch({
                type: DepartmentStructure.ActionTypes.SAVEDUTYCATEGORYSUCCESS,
                payload: {item: puts, index: index}
            });
            if ("function" === typeof callback) {
                callback(true);
            }
        }, error => {});
    }
}
export function deleteDutyCategory(deletes, index, callback) {
    return dispatch => {
        if (deletes) {
            departmentDutyService.deleteDutyCategory(deletes, res => {
                // console.log(res)
                dispatch({
                    type: DepartmentStructure.ActionTypes.DELETEDUTYCATEGORYSUCCESS,
                    payload: {index: index}
                });
                if ("function" === typeof callback) {
                    callback(res);
                }
            }, error => {
                if ("function" === typeof callback) {
                    callback(false);
                }
            });
        }else{
            dispatch({
                type: DepartmentStructure.ActionTypes.DELETEDUTYCATEGORYSUCCESS,
                payload: {index: index}
            });
            if ("function" === typeof callback) {
                callback(true);
            }
        }
    }
}
export function fetchDutyLevelList() {
    return dispatch => {
        departmentDutyService.fetchDutyLevelList(res => {
            res.data.Levels.forEach(level => {
                let levels = [];
                res.data.Types.forEach((type, index) => {
                    level.type_levels.forEach(category => {
                        if (category.type_id === type.id) {
                            levels[index] = {
                                id: category.id,
                                type_id: type.id,
                                level_id: category.level_id,
                                l_value: category.l_value,
                                organization_id:category.organization_id,
                            }
                        }
                    });
                    if (levels.length !== index + 1) {
                        levels[index] = {
                            id: null,
                            type_id: type.id,
                            level_id: level.id,
                            l_value: null,
                        }
                    }
                });
                level.type_levels = levels;
            });
            dispatch({
                type: DepartmentStructure.ActionTypes.FETCHDUTYLEVELSUCCESS,
                payload: {
                    dutyLevelList: res.data.Levels,
                    dutyLevelType: res.data.Types,
                    dutyLevelListStatus: true
                }
            })
        }, error => {});
    }
}
export function closeDutyLevelModal() {
    return dispatch => dispatch({
        type: DepartmentStructure.ActionTypes.CLOSEDUTYLEVELMODAL,
        payload: { dutyLevelListStatus: false }
    });
}
export function newDutyLevel(item){
    return dispatch => dispatch({
        type: DepartmentStructure.ActionTypes.NEWDUTYLEVEL,
        payload: { item: item }
    });
}
export function changeDutyLevel(index, column, value) {
    return dispatch => dispatch({
        type: DepartmentStructure.ActionTypes.CHANGEDUTYLEVEL,
        payload: { index: index, column: column, value: value }
    });
}
export function changeDutyLevelChild(index, childIndex, value) {
    return dispatch => dispatch({
        type: DepartmentStructure.ActionTypes.CHANGEDUTYLEVELCHILD,
        payload: { index: index, childIndex: childIndex, value: value }
    });
}
export function addDutyLevel(posts, index, callback) {
    return dispatch => {
        departmentDutyService.addDutyLevel(posts, res => {
            // console.log(posts);
            // console.log(res.data.Success);
            if(res.data.Success){
                dispatch({
                    type: DepartmentStructure.ActionTypes.ADDDUTYLEVELSUCCESS,
                    payload: {id: res.data.ModelId, index: index}
                });
            }
            else{
                _util.errorTips(res.data.Errors)
                throw new Error('新增职务等级失败')
            }
            
            if ("function" === typeof callback) {
                callback(true);
            }
        }, error => {});
    }
}
export function updateDutyLevel(posts, index, callback) {
    return dispatch => {
        departmentDutyService.updateDutyLevel(posts, res => {
            if ("function" === typeof callback) {                
                callback(res.data);
            }
        }, error => {});
    }
}
export function deleteDutyLevel(deletes, index, callback) {
    return dispatch => {
        if (deletes) {
            departmentDutyService.deleteDutyLevel(deletes, res => {
                dispatch({
                    type: DepartmentStructure.ActionTypes.DELETEDUTYLEVELSUCCESS,
                    payload: {index: index}
                });
                if ("function" === typeof callback) {
                    callback(true);
                }
            }, error => {
                if ("function" === typeof callback) {
                    callback(false);
                }
            });
        }else{
            dispatch({
                type: DepartmentStructure.ActionTypes.DELETEDUTYLEVELSUCCESS,
                payload: {index: index}
            });
            if ("function" === typeof callback) {
                callback(true);
            }
        }
    }
}
export function initDuty(callback) {
    return dispatch => {
        departmentDutyService.initDuty(res => {
            dispatch({
                type: DepartmentStructure.ActionTypes.INITDUTYSUCCESS,
                payload: {dutyOptions: res.data.types, initDutyStatus: true}
            });
            if ("function" === typeof callback) {
                callback(true);
            }
        }, error => {});
    }
}
export function closeDutyModal() {
    return dispatch => {
        dispatch({
            type: DepartmentStructure.ActionTypes.CLOSEDUTYMODAL,
            payload: {initDutyStatus: false}
        });
    }
}
export function addDuty(posts, callback) {
    return dispatch => {
        departmentDutyService.addDuty(posts, res => {
            dispatch({
                type: DepartmentStructure.ActionTypes.ADDDUTYSUCCESS,
                payload: {initDutyStatus: false}
            });
            if ("function" === typeof callback) {
                callback(true);
            }
        }, error => {});
    }
}
export function multiDeleteDuty(deletes, callback) {
    return dispatch => {
        departmentDutyService.multiDeleteDuty(deletes, res => {
            if (res.data.Success && "function" === typeof callback) {
                callback(true);
            }
            else{
                callback(false);
                message.error(`${res.data.Message}`, 4);
            }
        }, error => {});
    }
}
export function updateDuty(puts, callback) {
    return dispatch => {
        departmentDutyService.updateDuty(puts, res => {
            dispatch({
                type: DepartmentStructure.ActionTypes.UPDATEDUTYSUCCESS,
                payload: {initDutyStatus: false}
            });
            if ("function" === typeof callback) {
                callback(true);
            }
        }, error => {});
    }
}
export function fetchDepartmentDutyList(page = 1) {
	return dispatch => {
		departmentDutyService.fetchDepartmentDutyList(page, res => {
            let data = [];
            res.data.Data.forEach(result => {
                let item = {
                    id: result.id,
                    name: result.name,
                    type_id: result.type_id,
                    type_name: result.type_name,
                    level_bottom: result.level_bottom,
                    level_top: result.level_top,
                    description: result.description
                }
                data.push(item);
            });
			dispatch({
				type: DepartmentStructure.ActionTypes.FETCHDEPARTMENTDUTYLISTSUCCESS,
				payload: {
					dutyList: data,
					dutyListStatus: true,
                    totalDuty: res.data.Total,
                    pageSizeDuty: res.data.PageSize,
                    pageDuty: res.data.Page
				}
			})
		}, error => {});
	}
}


// 职位配置
export function fetchDepartmentPositionList(params) {
    return dispatch => {
        departmentPositionService.fetchDepartmentPositionList(params, res => {
            console.log(res);
            let position = res.data.Data.map(position => {
                return {
                    id: position.id,
                    name: position.name,
                    department_id: position.department_id,
                    department_name: position.department_name,
                    business_id: position.business_id,
                    business_name: position.business_name,
                    business_level_value: position.business_level_value,
                    staff_size: position.staff_size,
                    qualifications: position.qualifications,
                    responsibility_description: position.responsibility_description
                }
            });


            dispatch({
                type: DepartmentStructure.ActionTypes.FETCHDEPARTMENTPOSITIONLISTSUCCESS,
                payload: {
                    positionList: position,
                    positionListStatus: true,
                    totalPosition: res.data.Total,
                    pageSizePosition: res.data.PageSize,
                    pagePosition: res.data.Page
                }
            })
        }, err => {});
    }
}
export function initPosition(callback) {
    return dispatch => {
        departmentPositionService.initPosition(res => {
            // console.log(res);
            dispatch({
                type: DepartmentStructure.ActionTypes.INITPOSITIONSUCCESS,
                payload: {
                    initPosition: res.data,
                    initPositionStatus: true
                }
            })
            if ("function" === typeof callback) {
                callback(true);
            }
        }, err => {});
    }
}
export function addPosition(posts, callback) {
    return dispatch => {
        departmentPositionService.addPosition(posts, res => {
            if ("function" === typeof callback) {
                callback(true);
            }
        }, err => {});
    }
}
export function multiDeletePosition(deletes, callback) {
    return dispatch => {
        departmentPositionService.multiDeletePosition(deletes, res => {
            if ("function" === typeof callback) {
                if (res.status === 200 && res.data.Success) {
                    callback(true);
                }else{
                    callback(false, res.data.Message);
                }
            }
        }, err => {});
    }
}
export function updatePosition(puts, index, callback) {
    return dispatch => {
        departmentPositionService.updatePosition(puts, res => {
            dispatch({
                type: DepartmentStructure.ActionTypes.UPDATEPOSITIONSUCCESS,
                payload: {
                    position: puts,
                    index: index
                }
            })
            if ("function" === typeof callback) {
                callback(true);
            }
        }, err => {});
    }
}
export function initMovePosition(positionID, callback) {
    return dispatch => {
        departmentPositionService.initMovePosition(positionID, res => {
            console.log(res);
            dispatch({
                type: DepartmentStructure.ActionTypes.INITMOVEPOSITIONSUCCESS,
                payload: {
                    departmentList: res.data,
                    departmentListStatus: true
                }
            })
            if ("function" === typeof callback) {
                callback();
            }
        }, err => {});
    }
}
export function movePosition(posts, callback) {
    return dispatch => {
        departmentPositionService.movePosition(posts, res => {
            if ("function" === typeof callback) {
                callback(true);
            }
        }, err => {});
    }
}
export function createNewDepartmentEx(params = {}, callback) {
    return dispatch => departmentStructureService.createNewDepartmentEx(params, res => {
        dispatch({
            type: DepartmentStructure.ActionTypes.CREATENEWDEPARTMENTEXSUCCESS,
            payload: {
                reportList: res.data.Object.templates
            }
        }, () => {

        });
        if ('function' === typeof callback) {
            callback(true);
        }
    }, err => {})
}

export function updateDepartmentEx(params, callback) {
    return dispatch => departmentStructureService.updateDepartmentEx(params, res => {
        dispatch({
            type: DepartmentStructure.ActionTypes.UPDATEDEPARTMENTINITSUCCESS,
            payload: {
                initUpdateData: res.data.Object
            }
        });
        if ('function' === typeof callback) {
            callback();
        }
    });
} 


// WEBPACK FOOTER //
// ./src/actions/department-structure-actions.js